const url = "https://tigredesoleil.com"
const formUrl = "https://form.tigredesoleil.com/"
const purchaseSuccessUrl = "/purchase-thanks"
const purchaseCancelUrl = "/purchase"
const bookSuccessUrl = "/book-thanks"
const bookCancelUrl = "/book"

export { url, formUrl, purchaseSuccessUrl, purchaseCancelUrl, bookSuccessUrl, bookCancelUrl }